export enum SCORE_TYPE {
    LOGIC_TEST = 'LOGIC_TEST',
    PERSONALITY_TEST = 'PERSONALITY_TEST',
    INTERVIEW = 'INTERVIEW',
    CODING_TEST = 'CODING_TEST'
}
